<template>
  <slot :cartStore="cartStore" :accountStore="accountStore"></slot>
</template>

<script setup>
import { ref, inject } from 'vue';
import { useCartStore } from './cart/cart-store.js';
import { useAccountStore } from './account/account-store.js';
const cartStore = useCartStore();
const accountStore = useAccountStore();
const $notification = inject('$notification');

if(accountStore.isLoggedIn) {
  try {
    accountStore.getDetails();
  } catch (error) {
    $notification.show({
      class: 'error', // success, warning, error
      title: error?.response?.statusText || error?.name || 'Unknown title',
      status: error?.status?.status || error?.status || 'Unknown status',
      descr: error?.response?.data?.message || error?.message || 'Unknown message',
    });
  }
}

</script>